import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getEmployee (params) {
    return request.get(API.ADMIN_EMPLOYEE, params)
  },
  createEmployee (params) {
    return request.post(API.ADMIN_EMPLOYEE, params)
  },
  getDetailEmployee (params) {
    return request.get(API.ADMIN_EMPLOYEE_GET + params.id, params)
  },
  updateEmployee (params) {
    return request.post(API.ADMIN_EMPLOYEE_GET + params.id, params.formData)
  },
  deleteEmployee (params) {
    return request.delete(API.ADMIN_EMPLOYEE_GET + params.id)
  },
  getRole (params) {
    return request.get(API.ADMIN_ROLE, params)
  },
  getListHistoryLogs (params) {
    return request.get(API.ADMIN_GET_HISTORY_LOGS, params)
  },
  setSettings (params) {
    return request.put(API.ADMIN_EMPLOYEE_GET + params.userID + '/settings', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/admin/employee.js